module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAG1BMVEXd8ene8en/y60Wm2L/iD7///8Wm2L/iD7///9sRS6VAAAABnRSTlPFxsb+/v51kGnFAAAAM0lEQVRIx2NIQwOJHWhAvRwNMIxqGdUyqmVUy6iWUS2jWka1jGoZWC3GaMAgFA2ouKABANa+bKmqVLCQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/ie.png
// module id = gBMd
// module chunks = 0